import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const coupons = createApi({
  reducerPath: 'coupons',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    addCoupon: builder.mutation({
      query: (body) => ({
        url: '/coupons/add',
        method: 'POST',
        body,
      }),
    }),
    getAllCoupon: builder.query({
      query: (params) => {
        return {
          url: '/coupons',
          method: 'GET',
          params,
        };
      },
    }),
    getOpenCoupons: builder.query({
      query: () => ({
        url: '/coupons/open?limit=1000',
        method: 'GET',
      }),
    }),
    // PATCH /coupons/:id/status — permission: COUPON_UPDATE
    updateCouponStatus: builder.mutation<unknown, { id: string; status: 'active' | 'inactive' }>({
      query: ({ id, status }) => ({
        url: `/coupons/${id}/status`,
        method: 'PATCH',
        body: { status },
      }),
    }),
  }),
});

export const { useAddCouponMutation, useGetAllCouponQuery, useGetOpenCouponsQuery, useUpdateCouponStatusMutation } = coupons;
